import About1 from "../assets/img/vector/about-1.png";
import About2 from "../assets/img/vector/about-2.png";
import About3 from "../assets/img/vector/about-3.png";
import AboutVec from "../assets/img/vector/about-shape.png";
import Deliverd from "../assets/img/icon/delivered.png";
import Satis from "../assets/img/icon/satisfaction.png";
import HeroImg from "../assets/img/pictures/abtUs.jpg";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <>
      <div
        class="site-breadcrumb"
        style={{ backgroundImage: `url(${HeroImg})` }}
      >
        <div class="container">
          <div class="site-breadcrumb-wpr">
            <h2 class="breadcrumb-title">About Us</h2>
            <ul class="breadcrumb-menu clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li class="active">About Us</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="about-area-2 de-padding">
        <div class="container">
          <div class="about-wpr-2 grid-2">
            <div class="about-left-2">
              <div class="about-left-img">
                <div class="about-phase grid-2">
                  <div class="about-phase-1">
                    <img
                      src={About2}
                      alt="no image"
                      class="about-left-img-main mb-30"
                    />
                    <img
                      src={About3}
                      alt="no image"
                      class="about-left-img-main"
                    />
                  </div>
                  <div class="about-phase-2 element-center">
                    <img
                      src={About1}
                      alt="no image"
                      class="about-left-img-main"
                    />
                  </div>
                </div>
                <img
                  src={AboutVec}
                  alt="no image"
                  class="about-left-img-shape"
                />
              </div>
            </div>
            <div class="about-right-2 pl-30">
              <span class="hero-sub-title mb-20">
                <span class="hero-line"></span>
                About Company
              </span>
              <h2 class="heading-1 mb-30">
                Digital &amp; trusted transport logistic company
              </h2>
              <p class="mb-50">
                Welcome to Hallgord Logistics, your trusted partner in the world
                of efficient and reliable logistics solutions. Our journey began
                in Erbil, Iraq, where we established ourselves as a locally
                based logistic company with a commitment to excellence. With a
                dedicated team and a strong vision, we've grown into a
                competitive and service-oriented freight forwarding
                organization.
                <br></br>
                <br></br>
                At Hallgord, we understand the importance of delivering value
                through exceptional quality service. Our story is one of
                continuous growth, built on the foundation of trust and
                reliability. We take pride in our strong relationships with
                clients and partners, fostering connections that enable us to
                navigate the complex world of logistics with confidence.
                <br></br>
                <br></br>
                Driven by a passion for efficient cargo movement, we strive to
                achieve economic efficiency that translates into seamless
                freight processes and timely deliveries. Our dedication to
                excellence ensures that every step of the logistics journey is
                handled with care, from origin to destination.
              </p>
              <div class="about-opt-2">
                <div class="about-opt-left-2">
                  <p>Our Staff Completes A Project Very Quickly.</p>
                  <a href="#" class="btn-3">
                    Read More
                  </a>
                </div>
                <div class="about-opt-right-2">
                  <div class="about-opt-right-box-2 about-opt-right-pd">
                    <div class="about-opt-icon-2">
                      <i>
                        <img src={Deliverd} alt="no image" />
                      </i>
                    </div>
                    <div class="about-opt-desc-2">
                      <h2 class="heading-1">1959+</h2>
                      <h5 class="heading-5 mb-0">Delivery Successful</h5>
                    </div>
                  </div>
                  <div class="about-opt-right-box-2 about-opt-right-pd">
                    <div class="about-opt-icon-2">
                      <i>
                        <img src={Satis} alt="no image" />
                      </i>
                    </div>
                    <div class="about-opt-desc-2">
                      <h2 class="heading-1">100%</h2>
                      <h5 class="heading-5 mb-0">Clients Satisfaction</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
